import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Guidelines() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
       <div className="max-w-5xl mx-auto px-6 py-12 mb-40">
      <h1 className="text-3xl font-bold mb-8">
        Guidelines for Article Contributors
      </h1>

      <p className="mb-8  space-y-3 text-justify">
        Mizoram Economic Review accepts high quality research papers in the
        areas of theoretical or practical aspects of economics studies,
        socio-economics, sustainable development, and public policy research.
        To maintain uniformity of paper submission and ensure fast processing
        of articles, contributors are expected to adhere to the following
        guidelines when submitting their manuscripts.
      </p>

      {/* General Submission Guidelines */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          A. General Submission Guidelines
        </h2>

        <ol className="list-decimal pl-6 text-justify  space-y-3">
          <li>All articles must be original and unpublished.</li>
          <li>
            Articles should be relevant to the scope and themes of the journal.
          </li>
          <li>
            Submissions must be in English and adhere to proper grammar and
            spelling standards.
          </li>
          <li>
            Articles exhibiting more than 10% similarity shall be rejected.
            Manuscripts showing more than 25% AI-generated content, as
            indicated by AI-detection tools and confirmed through editorial
            assessment, may also be rejected.
          </li>
          <li>
            Articles should not exceed 6,000 words, excluding tables and
            references. Abstracts of postgraduate and doctoral research should
            not exceed 2,000 words, excluding tables and references.
          </li>
        </ol>
      </section>

      {/* Formatting Requirements */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          2. Formatting Requirements
        </h2>

        <ol className="list-decimal pl-6 space-y-3">
          <li>
            Articles should be submitted in Microsoft Word format (.doc or
            .docx) on A4 size paper.
          </li>
          <li>
            Use a clear, professional font (e.g., Times New Roman, size 12)
            with 1.5-line spacing.
          </li>
          <li>
            Include appropriate headings and subheadings to enhance
            readability.
          </li>
          <li>Citations and references must follow APA style.</li>
        </ol>
      </section>

      {/* Structure */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          3. Structure of the Article
        </h2>

        <ul className="list-disc pl-6 space-y-3">
          <li>
            <strong>Title Page:</strong> Title, author(s) name(s),
            affiliation(s), and contact details.
          </li>
          <li>
            <strong>Abstract:</strong> A concise summary (150–250 words)
            outlining the main objectives, methods, and findings.
          </li>
          <li>
            <strong>Keywords:</strong> 4–6 relevant keywords.
          </li>
          <li>
            <strong>Main Body:</strong> Structured sections such as
            Introduction, Literature Review, Methods, Results, Discussion, and
            Conclusion.
          </li>
          <li>
            <strong>References:</strong> A complete list of sources cited in
            the article.
          </li>
          <li>
            <strong>Appendices (if applicable):</strong> Supplementary
            materials, data, or figures.
          </li>
        </ul>
      </section>

      {/* Images and Tables */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          5. Image and Table Guidelines
        </h2>

        <ol className="list-decimal pl-6 space-y-3">
          <li>
            Figures, tables, and images should be high-resolution and properly
            labeled.
          </li>
          <li>
            Provide captions and indicate placement within the text.
          </li>
          <li>
            Ensure that all graphical content is original or appropriately
            credited.
          </li>
        </ol>
      </section>

      {/* Submission Process */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">
          6. Submission Process
        </h2>

        <ol className="list-decimal pl-6 space-y-3">
          <li>
            Email your manuscript to{" "}
            <a
              href="mailto:jametea@yahoo.com"
              className="text-blue-600 hover:underline"
            >
              jametea@yahoo.com
            </a>
          </li>
          <li>Include a brief author bio (50–100 words).</li>
          <li>
            Our editorial team will review the submission and provide feedback
            within 4–8 weeks.
          </li>
        </ol>
      </section>

      {/* Review and Publication */}
      <section>
        <h2 className="text-2xl font-semibold mb-4">
          7. Review and Publication
        </h2>

        <ol className="list-decimal pl-6 space-y-3">
          <li>All submissions undergo a peer-review process.</li>
          <li>
            Authors may be required to make revisions before acceptance.
          </li>
          <li>
            Accepted articles will be published in the next available issue.
          </li>
          <li>
            A nominal Article Processing Charge (APC) shall be payable upon
            acceptance of the manuscript for publication:
            <ul className="list-disc pl-6 mt-2">
              <li>₹1,000 for a single-authored paper.</li>
              <li>
                ₹1,000 for the first author and ₹500 for each additional
                co-author in jointly authored papers.
              </li>
            </ul>
          </li>
        </ol>

        <div className="mt-8 p-4 bg-gray-100 rounded-lg">
          <p>
            For any queries, please contact our editorial team via email. We
            look forward to your contributions!
          </p>
        </div>
      </section>
    </div>
      <Footer />
    </div>
  );
}
